import { render, staticRenderFns } from "./TextWithPopover.vue?vue&type=template&id=2b5f6984&"
import script from "./TextWithPopover.vue?vue&type=script&lang=js&"
export * from "./TextWithPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports